export const match = (expression: any, cases: any) => {
  return cases[expression] || cases?.default;
};
